export default __webpack_public_path__ + "static/media/coimage.9506af77.jpeg";